import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/** Extract a human-readable error from an axios error object.
 *  Handles:
 *   - FastAPI HTTPException: { detail: "..." }         → the string
 *   - FastAPI 422 validation: { detail: [{loc, msg}] } → "msg (loc)"
 *   - 500 with no body / HTML page                     → "HTTP 500 (<status text>)"
 *   - Network error (no response)                      → "Network error — <message>"
 */
export function errMsg(e, fallback = "Failed") {
  if (!e) return fallback;
  const r = e.response;
  if (!r) return `Network error — ${e.message || fallback}`;
  const d = r.data?.detail;
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d) && d.length) {
    return d.map((x) => (x.msg ? `${x.msg}${x.loc ? ` (${x.loc.join(".")})` : ""}` : JSON.stringify(x))).join("; ");
  }
  if (d && typeof d === "object") {
    try { return JSON.stringify(d); } catch { /* ignore */ }
  }
  return `HTTP ${r.status}${r.statusText ? ` — ${r.statusText}` : ""}`;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pnc_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 401) {
      localStorage.removeItem("pnc_token");
      localStorage.removeItem("pnc_user");
    }
    // 403 "Admin only" means our local admin flag is out of sync with the
    // server. Refresh it on the next page load by clearing cached user — the
    // AuthProvider rehydrate (/auth/me) will pull the fresh is_admin and
    // RequireAuth will route the user away from admin-only pages if needed.
    if (status === 403 && typeof detail === "string" && detail.toLowerCase().includes("admin")) {
      try {
        const cached = JSON.parse(localStorage.getItem("pnc_user") || "null");
        if (cached && cached.is_admin) {
          cached.is_admin = false;
          localStorage.setItem("pnc_user", JSON.stringify(cached));
        }
      } catch { /* ignore */ }
    }
    return Promise.reject(err);
  }
);

export default api;
